'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _reactAddons = require('react/addons');

var _reactAddons2 = _interopRequireDefault(_reactAddons);

/* Stores */

var _storesModuleInspector = require('stores/module-inspector');

var _storesModuleInspector2 = _interopRequireDefault(_storesModuleInspector);

var classSet = _reactAddons2['default'].addons.classSet;
exports['default'] = _reactAddons2['default'].createClass({
  displayName: 'property-group',

  render: function render() {
    var _props = this.props;
    var selected = _props.selected;
    var children = _props.children;
    var name = _props.name;

    var listNode = null;

    if (children && children.length) {
      listNode = _reactAddons2['default'].createElement(
        'div',
        { className: 'list-component properties' },
        children
      );
    }

    var classes = {
      'item-component': true,
      'property-group-component': true,
      'selected': selected
    };

    return _reactAddons2['default'].createElement(
      'div',
      { className: classSet(classes) },
      _reactAddons2['default'].createElement(
        'div',
        { className: 'title', onClick: this._onClick },
        _storesModuleInspector2['default'].translate(name + '_group')
      ),
      listNode
    );
  },

  _onClick: function _onClick(evt) {
    evt.preventDefault();

    var _props2 = this.props;
    var onClick = _props2.onClick;
    var name = _props2.name;

    if (onClick) {
      onClick(name);
    }
  }
});
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/property-group.js
 **/